import {
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILED,
  CLEAR_SEARCH,
} from "./types";
import { searchService } from "./api";
import {
  classifyResourceTopic,
  trackAnalyticsEvent,
} from "../../analytics";

export const searchAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: SEARCH });
    const response = await searchService(params)();
    const results = response?.data || {};
    const resultCount = Object.values(results).reduce(
      (sum, items) => sum + (Array.isArray(items) ? items.length : 0),
      0
    );
    trackAnalyticsEvent("search_submitted", {
      search_topic: classifyResourceTopic(params?.q),
      keyword_length: (params?.q || "").trim().length,
      result_count: resultCount,
      has_results: resultCount > 0,
    });
    dispatch({
      type: SEARCH_SUCCESS,
      data: response?.data,
    });
  } catch (error) {
    trackAnalyticsEvent("search_submitted", {
      search_topic: classifyResourceTopic(params?.q),
      keyword_length: (params?.q || "").trim().length,
      result_count: 0,
      has_results: false,
    });
    dispatch({ type: SEARCH_FAILED });
  }
};

export const clearSearchAction = () => (dispatch) => {
  dispatch({ type: CLEAR_SEARCH });
};
